module.exports = __webpack_public_path__ + "static/vintage-5f26c94aadc3e40bd963550e694b4c84.png";